module.exports = __webpack_public_path__ + "img/imagen3.a465d272.png";